import React from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Chip,
} from "@material-ui/core";
import {
  Keyboard as KeyboardIcon,
  FolderOpen as FolderIcon,
  LocalPharmacy as PharmacyIcon,
} from "@material-ui/icons";
import { usePdvStyles } from "../styles/pdvStyles";
import PdvCartButton from "./PdvCartButton";

const PdvHeader = ({
  ticketId,
  cartItemCount,
  cartTotal,
  hasCartItems,
  onCartClick,
  onHelpClick,
  onQuotesClick,
  showQuotes = true,
}) => {
  const classes = usePdvStyles();

  return (
    <Box className={classes.header}>
      <Box className={classes.headerTitle}>
        <PharmacyIcon />
        <Typography variant="subtitle1" component="span">
          PDV
        </Typography>
        {ticketId && (
          <Chip
            size="small"
            label={`#${ticketId}`}
            variant="outlined"
            color="primary"
          />
        )}
      </Box>

      <Box className={classes.headerActions}>
        <Tooltip title="Atalhos do teclado (F1)">
          <IconButton size="small" onClick={onHelpClick}>
            <KeyboardIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        {showQuotes && (
          <Tooltip title="Buscar orçamentos">
            <IconButton size="small" onClick={onQuotesClick}>
              <FolderIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        <PdvCartButton
          itemCount={cartItemCount}
          total={cartTotal}
          hasItems={hasCartItems}
          onClick={onCartClick}
        />
      </Box>
    </Box>
  );
};

export default React.memo(PdvHeader);
